import React, { ReactNode, useState } from "react";
import { EFaultedReason } from "../../../Model/ModuleState";

import styles from "./MultiplePlateRetrievalFailureModal.module.css";
import MessageContainer from "../MessageContainer/MessageContainer";
import SvgError from "../../../Icons/NotificationMessage/Error";
import MtiButton from "../../Buttons/MtiButton";
import { useTypedSelector } from "../../../redux/reducers/RootReducer";
import { getModules } from "../../../redux/reducers/ModuleReducer";
import { EModuleType } from "../../../Model/EModuleType";
import { getModuleState } from "../../../redux/reducers/ModuleStateReducer";
import PlateApi from "../../../api/PlateApi";

type MultiplePlateRetrievalFailureModalProps = {
  title: string;
  message: ReactNode;
  detail: any;
  reason: EFaultedReason;
};

const MultiplePlateRetrievalFailureModal = (
  props: MultiplePlateRetrievalFailureModalProps
) => {
  const { title, message, detail, reason } = props;

  const imagerModules = useTypedSelector((state) =>
    getModules(state, EModuleType.IMAGER)
  );
  const imagerIdentifier = imagerModules?.[0]?.identifier;
  const imagerState = useTypedSelector((state) =>
    getModuleState(state, imagerIdentifier)
  )?.imager;

  const [isOk, setIsOk] = useState( reason === EFaultedReason.MultiplePlateRetrievalFailureAcknowledged );
  const [isAcknowledge, setIsAcknowledge] = useState(
    reason === EFaultedReason.MultiplePlateRetrievalFailureAcknowledged
  );

  return (
    <>
      {isOk ? (
        <div className={styles.container}>
          <div className={styles.title}>
            {isAcknowledge ? title : "Clear Registered Plate in Imager"}
          </div>
          <div className={styles.body}>
            <p className={styles.message}>
              {isAcknowledge
                ? message
                : `Do you want to remove registration for plate ${imagerState?.plate?.barcode}?`}
            </p>
            <MessageContainer
              message={
                isAcknowledge
                  ? detail
                  : "System failed to retrieve plate from imager"
              }
              variant={isAcknowledge ? "error" : "warning"}
              icon={isAcknowledge ? <SvgError /> : undefined}
            />
          </div>
          {!isAcknowledge && (
            <div className={styles.footer}>
              <MtiButton
                onClick={() => {
                  PlateApi.acknowledgeMultiplePlateRetrievalError();
                  setIsAcknowledge(true);
                }}
                variant="secondary"
                colorVariant="default"
              >
                LATER
              </MtiButton>
              <MtiButton
                onClick={() => {
                  PlateApi.clearImagerPlateRegistration().then((result) => {
                    console.log(result);
                  }).catch((result) => {
                    console.log(result);
                  });
                }}
                variant="primary"
                colorVariant="default"
              >
                REMOVE
              </MtiButton>
            </div>
          )}
        </div>
      ) : (
        <div className={styles.container}>
          <div className={styles.title}>{title}</div>
          <div className={styles.body}>
            <p className={styles.message}>{message}</p>
            <MessageContainer
              message={detail}
              variant="error"
              icon={<SvgError />}
            />
          </div>
          <div className={styles.footer}>
            <MtiButton
              onClick={() => setIsOk(true)}
              variant="primary"
              colorVariant="default"
            >
              OK
            </MtiButton>
          </div>
        </div>
      )}
    </>
  );
};

export default MultiplePlateRetrievalFailureModal;
